import ActionName from './ActionName';

export default ActionName;
export { ActionName };
